import React, { useEffect, useState } from "react";
import ColorsCircles from "./colors-roles";
import {
  calculatePercentMotivators,
  colorInterpreter,
} from "../../../../helpers/functions";

const colors = (index) => {
  const allColors = {
    amarillo: "#FFF280",
    rojo: "#FF8080",
    azul: "#8090E8",
    verde: "#80C6A7",
  };
  return allColors[index] || "";
};
const InfoCharge = (props) => {
  const { charge } = props;
  const [percentMotivators, setPercentMotivators] = useState([]);
  useEffect(() => {
    if (charge) {
      const response = calculatePercentMotivators(charge?.competences);
      setPercentMotivators(response);
    }
    //eslint-disable-next-line
  }, []);

  return (
    <div className="gm-info-charge-container">
      <div className="gm-name-description-charge">
        <h2>{charge?.name}</h2>
        <span>DESCRIPCIÓN DEL CARGO</span>
        <p>{charge?.description}</p>
      </div>
      <div className="gm-skills-charge">
        <span>COMPETENCIAS REQUERIDAS</span>
        <div className="gm-table-competences-selected">
          {charge?.competences.map((skills) => (
            <div key={skills.id}>
              {" "}
              <span> {skills.name}</span>{" "}
              <div>
                {skills.colorType.map((colors) => (
                  <ColorsCircles colors={colors} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="gm-bars-charge">
        <span>PERFIL DE PERSONALIDAD</span>
        <div className="gm-bars-container">
          {percentMotivators?.map((element) => (
            <div>
              <div
                style={{
                  height: `${element.value}%`,
                  backgroundColor: colors(element.name),
                }}
              ></div>
              <span>{colorInterpreter(element.name)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InfoCharge;
